import React, {Component} from 'react';
import {Spinner} from "reactstrap";
import {app} from "app/app";
import {Modal} from "components/common/Modal";
import 'assets/sass/dashboard/deposits/UserAccountData.scss';
import { AppContext } from 'app/state/AppContext';

export class WalletRow extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.walletDeletionConfirmModal = React.createRef();

        this.state = {
            user: app.currentUser(),
            risk: false
        };

        this.eraseWallet = this.eraseWallet.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.renderRejectedWalletText = this.renderRejectedWalletText.bind(this);
    }

    componentDidMount() {
        let risk = this.props.data.risk && app.isRiskWallet(this.props.data.risk);
        if(risk){
            this.setState({risk});
        }
    }

    eraseWallet() {
        app.apiClient().deleteWalletBookEntry(this.props.data, this.props.handleDeleteWallet);
    }

    renderWalletDeletionConfirmModal() {
        const wallet = this.props.data;
        return (
            // TODO-CVU: change all text appearences of CBU to CBU/CVU
            <Modal ref={this.walletDeletionConfirmModal}
                   trigger={<div className="btn-delete"></div>}
                   type={Modal.MODAL_TYPES.data}
                   title="Borrar wallet"
                   subtitle={`¿Desea realmente borrar la wallet con alias ${wallet.alias()}?`}>
                <div className="modal-box">
                    <div className="separator"></div>
                    {this.renderFormActions()}
                </div>
            </Modal>
        )
    }

    renderFormActions() {
        if (this.props.operationInProgress) {
            return <Spinner className="spinner-color"/>;
        } else {
            return (
                <div>
                    <button className="cta-button" onClick={this.eraseWallet}>BORRAR</button>
                    <br/>
                    <button className="link-btn" onClick={this.closeModal}>Cancelar</button>
                </div>
            );
        }
    }

    closeModal() {
        this.walletDeletionConfirmModal.current.hideModal();
    }

    renderAlias() {
        const wallet = this.props.data;
        if (wallet.alias()) {
            return (<p>{wallet.alias()}</p>);
        }
    }

    renderAddress() {
        const wallet = this.props.data;
        if (wallet._address) {
            return (<p>{wallet._address}</p>);
        }
    }

    renderRejectedWalletText() {
        return <span className="risk-wallet">No vas poder utilizarla para realizar ninguna operación dentro de Buenbit.</span>
    }

    render() {
        const wallet = this.props.data;
        const { getCurrencyInstance } = this.context;

        return (
            <div className={"card-user " + (this.props.isSelected ? 'active' : '') + (this.state.risk ? ' risk' : '')}
                 onClick={!this.state.risk && (() => this.props.handleAccountSelect(wallet))}>
                <div className="avatar">{!this.state.risk && wallet.aliasInitials()}</div>
                <div className="card-user--content">
                    {this.renderAlias()}
                    {this.renderAddress()}
                    <span>Wallet {getCurrencyInstance(wallet.currency()).asVerbose()}</span>
                    {this.state.risk ? this.renderRejectedWalletText() : null}
                </div>
                <div className="card-user--delete">
                    {this.renderWalletDeletionConfirmModal()}
                </div>
            </div>
        );
    }
}
